<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bCSBqR/tc-custom/9781646567157.jpg?1723403555747" alt="This image is the cover for the book In the Name of Magic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Name of Magic
      </h1>
      <p class="bookDescription body article font2">
        <p>Nonmagical people are being demonized and falsely blamed for Magnifico’s economic problems after Queen Vivian’s bloody rise to power. But politics very quickly become more than abstract views to argue about when secret police wolves are deployed throughout the country to kill those born without magical abilities.<br/><br/>Seventeen-year-old Maximillian’s best friend Katherine is one such nonmagical person. In a bid to keep her safe, Maximillian turns to the queen’s estranged younger brother, a man thought to be dead until recently.<br/><br/>Prince Stefan is nineteen years old and has been in hiding from his family for years. He has no desire to resurface in the political world. Can Maximillian convince him the country needs him before it’s too late?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Bedell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ea7b95f